import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

import RatingTable from "../RatingTable";
import { AddTalentReviewCandidate } from "../../../types/addReviewCandidate";

const AthleticismPhysicalStep = () => {
  const { t } = useTranslation("goHire", { keyPrefix: "components.reviewCandidateModal" });
  const { t: tTalentReport } = useTranslation("goHire", { keyPrefix: "components.reviewCandidateModal.talentReport" });

  const { control } = useFormContext<AddTalentReviewCandidate>();

  const skills: { title: string; description: string; fieldName: keyof AddTalentReviewCandidate }[] = [
    {
      title: tTalentReport("acceleration"),
      description: tTalentReport("quicknessInFirstSteps"),
      fieldName: "acceleration",
    },
    { title: tTalentReport("topSpeed"), description: tTalentReport("maximumPaceSustained"), fieldName: "topSpeed" },
    { title: tTalentReport("strength"), description: tTalentReport("powerInDuelsShielding"), fieldName: "strength" },
    {
      title: tTalentReport("endurance"),
      description: tTalentReport("staminaToMaintainPerformance"),
      fieldName: "endurance",
    },
    { title: tTalentReport("agility"), description: tTalentReport("abilityToChangeDirection"), fieldName: "agility" },
    {
      title: tTalentReport("flexibilityCoordination"),
      description: tTalentReport("controlOfBodyMovements"),
      fieldName: "flexibilityCoordination",
    },
  ];

  return (
    <Box sx={[styles.container, styles.containerPadding]}>
      <RatingTable ratings={skills} control={control} />
    </Box>
  );
};

export default AthleticismPhysicalStep;

const styles = {
  containerPadding: {
    px: "24px",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
};
